import type { ComponentProps } from "react";

export default function SuccessCircleIcon(props: ComponentProps<"svg">) {
  return (
    <svg width="40" height="41" viewBox="0 0 40 41" fill="none" {...props}>
      <circle cx="20" cy="20.6924" r="20" fill={props.fill || "currentColor"} />
      <path
        d="M17.6095 27.6851C17.219 28.0756 16.5859 28.0756 16.1953 27.6851L11.4141 22.9039C11.0236 22.5134 11.0236 21.8802 11.4141 21.4897L12.1683 20.7355C12.5588 20.345 13.192 20.345 13.5825 20.7355L16.1953 23.3483C16.5859 23.7388 17.219 23.7388 17.6095 23.3483L26.4177 14.5401C26.8083 14.1496 27.4414 14.1496 27.832 14.5401L28.5861 15.2943C28.9767 15.6848 28.9767 16.318 28.5861 16.7085L17.6095 27.6851Z"
        fill="white"
      />
    </svg>
  );
}
